import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeMap = {
  dashboard:    'Dashboard',
  stores:       'Stores',
  new:          'New',
  edit:         'Edit',
  categories:   'Categories',
  products:     'Products',
  variants:     'Variants',
  orders:       'Orders',
  payments:     'Payments',
  'wallet-dues':'Wallet Dues',
  reports:      'Reports',
  settings:     'Settings',
};

const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length <= 1) return null;

  const crumbs = segments.map((seg, i) => {
    const path = '/' + segments.slice(0, i + 1).join('/');
    const isId = /^[a-f0-9]{24}$/.test(seg) || /^\d+$/.test(seg);
    const label = isId ? `#${seg.slice(0, 8)}…` : (routeMap[seg] || seg);
    const isLast = i === segments.length - 1;
    return { path, label, isLast };
  });

  return (
    <nav aria-label="breadcrumb" className="flex items-center gap-1 text-xs text-slate-400 mb-4">
      <Link to="/dashboard" className="flex items-center hover:text-purple-600 transition-colors">
        <Home className="w-3 h-3" />
      </Link>
      {crumbs.map(({ path, label, isLast }) => (
        <span key={path} className="flex items-center gap-1">
          <ChevronRight className="w-3 h-3 text-slate-300" />
          {isLast ? (
            <span className="text-slate-600 font-medium">{label}</span>
          ) : (
            <Link to={path} className="hover:text-purple-600 transition-colors">
              {label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
